import * as globals from "./site";
import * as bootstrap from "bootstrap";
import $ from 'jquery';
import { MarkerClusterer, Renderer } from "@googlemaps/markerclusterer";
import { Marker } from "@googlemaps/markerclusterer/dist/marker-utils";


interface infoWindowRequest {
    url: string;
}

namespace Controls.GoogleMap {

    // https://developers.google.com/maps/documentation/javascript?hl=fr
    // https://googlemaps.github.io/js-markerclusterer/interfaces/Renderer.html




    export interface MapOptions {
        selector: string;
        center?: google.maps.LatLng | google.maps.LatLngLiteral;
        mapId: string;
        mode: MapMode,
        zoom: number,
        minZoom: number,
        maxZoom: number,
        local?: Locals;
        cluster?: MarkerClusterer;// AdvancedMarkerClusterer;
        distanceUnit?: DistanceUnit | string;
        popupUrl: string;
        sliderUrl?: string;
        displayHotelsSliders?: boolean;
        markersStorage?: Storage;
        storageKey: string;        

    }
    export enum DistanceUnit {
        km,
        mi
    }



    export interface AdvancedMarkerClusterer {
        MarkerClusterer(map: google.maps.Map, markers: google.maps.marker.AdvancedMarkerElement[]): Function;
        clearMarkers: Function;
        removeMarker(marker: google.maps.marker.AdvancedMarkerElement): Function;
        removeMarkers(markers: google.maps.marker.AdvancedMarkerElement[]): Function;
        addMarker(marker: google.maps.marker.AdvancedMarkerElement): Function;
        addMarkers(markers: google.maps.marker.AdvancedMarkerElement[]): Function;
    }

    export interface Locals {
        loading: string;
        myLocation: string;
        errors: MapErrors;
    }

    export interface MapErrors {
        errorLoadingHotel: string;
        errorLoadingData: string;
    }

    export enum MapMode {
        List = 1,
        Simple = 2,
        Booking = 3
    }
    export interface Marker {
        title?: string;
        position: google.maps.LatLngLiteral;
    }
    export interface SimpleMarker extends Marker {
        content?: Node;
        //title?: string;
        //position: google.maps.LatLngLiteral;
        contentUrl?: string;
        id?: any;
        allowCluster?: boolean;
    }



    export interface MarkerViewModel {
        key: string;
        category: MarkerCategories;
        infoWindow?: any;
        position: google.maps.LatLngLiteral;
        icon: IconViewModel;
        detailsUrl?: string;
        displayPrice?: string;
        isYouthOffer?: boolean;
        title: string;
        zIndex?: number;
        views?: number;
        className?: string;
        selector?: string;
        allowCluster: boolean;
        allowArrival: boolean;
        allowDeparture: boolean;
    }

    export interface Size {
        width: number;
        height: number;
    }

    export interface IconViewModel {
        size: Size;
        url: string;
        className: string;
        template?: string;
    }

    export enum MarkerCategories {
        None = 0,
        EventLocation = 1,
        Hotel = 2,
        POI = 3,
        NavPosition = 4,
    }
}

export interface IMapView {

}

export class MapView implements IMapView {


    private listeners: { [key: string]: { callback: (data?: any) => void, once?: boolean }[] } = {};




    public onMapReady?: () => void

    private _options: Controls.GoogleMap.MapOptions;
    private _mapElement: HTMLElement;
    private _map: google.maps.Map;
    private _clusterer: MarkerClusterer;// Controls.GoogleMap.AdvancedMarkerClusterer;

    private _infoWindow: google.maps.InfoWindow;


    private _isLoaded: boolean;
    private _isLoading: boolean;

    private loader: Function;

    private directionsService: google.maps.DirectionsService;
    private directionsRenderer: google.maps.DirectionsRenderer;

    private _request: any;
    private _radius: google.maps.Circle;
    private _local: Controls.GoogleMap.Locals;
    private _markersStore: Storage;

    //private markerElement: Function;


    private _markers: google.maps.marker.AdvancedMarkerElement[];
    //private fnCreateMarker: Function;
    //private MarkerLibrary: google.maps.MarkerLibrary;

    private _initGooogleMapFunction: Function;

    public get defaultMarkerIcon(): string {
        return window["DefaultMarkerIcon"];
    }
    public get defaultMarkerClass(): string{
        return window["DefaultMarkerClass"];
    }

    public constructor(initFunction: Function, options: Controls.GoogleMap.MapOptions) {

        this._initGooogleMapFunction = initFunction;
        this._mapElement = document.querySelector(options.selector);
        this._options = options;
        this._markersStore = options.markersStorage;
        this._clusterer = options.cluster;
    
        //this._mapElement.dispatchEvent(  'map-ready');
        this._markers = [];

        if (typeof options.mode === "string") this._options.mode = Controls.GoogleMap.MapMode[options.mode as keyof typeof Controls.GoogleMap.MapMode];
        if (options.distanceUnit == null) this._options.distanceUnit = Controls.GoogleMap.DistanceUnit.km;
        else {
            if (typeof options.distanceUnit === "string") {
                this._options.distanceUnit = Controls.GoogleMap.DistanceUnit[options.distanceUnit as keyof typeof Controls.GoogleMap.DistanceUnit];
            }
        }

        if (options.local == null) {
            this._options.local = {
                loading: 'loading ...',
                myLocation: 'my location',
                errors: {
                    errorLoadingHotel: 'Error loading hotels',
                    errorLoadingData: 'errorLoadingData'
                }
            };
        }
        this._local = this._options.local;


    }

    public addMarkerElem: Function;

    //#region events
    // Ajouter un écouteur standard
    public on(event: string, callback: (data?: any) => void): MapView {
        if (!this.listeners[event]) {
            this.listeners[event] = [];
        }
        this.listeners[event].push({ callback });
        return this;
    }

    // Ajouter un écouteur qui s'exécute une seule fois
    public one(event: string, callback: (data?: any) => void): MapView {
        if (!this.listeners[event]) {
            this.listeners[event] = [];
        }
        this.listeners[event].push({ callback, once: true });
        return this;
    }

    // Déclencher un événement
    private emit(event: string, data?: any): MapView {
        if (this.listeners[event]) {
            // Filtrer les écouteurs à exécuter et ceux à supprimer
            this.listeners[event] = this.listeners[event].filter(listener => {
                listener.callback(data);
                // Garder les écouteurs qui ne sont pas marqués comme "once"
                return !listener.once;
            });
        }
        return this;
    }

    // Supprimer tous les écouteurs (optionnel : pour un événement spécifique)
    public clearEventListener(event?: string): MapView {
        if (event) {
            // Supprimer tous les écouteurs pour un événement spécifique
            delete this.listeners[event];
        } else {
            // Supprimer tous les écouteurs pour tous les événements
            this.listeners = {};
        }
        return this;
    }
    //#endregions

    //#region init 
    public isLoaded(): boolean {
        return this._isLoaded;
    }

    private async init(): Promise<void> {

        const { Map, InfoWindow } = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;
        const { AdvancedMarkerElement, AdvancedMarkerClickEvent, Marker, PinElement, CollisionBehavior, Animation } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;
        const _ = this;
        return new Promise((resolve, reject) => {


            this.directionsService = new google.maps.DirectionsService();
            this.directionsRenderer = new google.maps.DirectionsRenderer();


            const map = new Map(this._mapElement, {
                center: this._options.center,
                zoom: this._options.zoom,
                mapId: this._options.mapId,
                minZoom: this._options.minZoom,
                maxZoom: this._options.maxZoom,
                fullscreenControl: false,
                zoomControl: false,
                streetViewControl: false,
                mapTypeControl: false,
                gestureHandling: 'greedy' // Allow direct scrolling on the map 

            });

            this.addMarkerElem = function (position: google.maps.LatLngLiteral) {
                return new google.maps.marker.AdvancedMarkerElement({
                    map: map,
                    position: position
                });
            }

            this.directionsRenderer.setMap(map);
            this.directionsRenderer.setOptions(
                {
                    markerOptions: {
                        visible: false
                    },
                    preserveViewport: false,
                    suppressMarkers: true,
                    suppressBicyclingLayer: true,
                    draggable: true,
                    hideRouteList: false,
                    suppressPolylines: false,
                    panel: document.getElementById('map-direction-content')
                });

            //this._markers = [];
            this._clusterer = new MarkerClusterer({ map });
            this._infoWindow = new InfoWindow();
            
            this._map = map;
            const mapView = this;

            
           
            this._infoWindow.addListener("close", o => {                
                _._infoWindow.setContent(null);
                _._infoWindow.setHeaderContent(null);
                _._infoWindow.close();
            });



            $('.map-controls[data-placement]').each((i, c) => {
                var placement = google.maps.ControlPosition[c.dataset.placement as keyof typeof google.maps.ControlPosition];
                map.controls[placement].push(c);
            });


            $(document).on("change", 'input[type=radio][name="toggleMapView"]', function () {
                mapView.toggleView(this);
            });

            $(document).on("click", 'a[data-toggle=marker]', function () {
                mapView.showPopup(this);
            });

            $(document).on("click", "[data-toggle='showOnMap']", function () {
                const el = this;

                if (!mapView.isLoaded()) {
                    $(mapView).one('map:loaded', function () {
                        mapView.showPopup(el, true);
                    });
                }
                var listMode = 'map';

                if ($(window).width() >= 992) {
                    listMode = 'combined';
                }

                $(`#view-${listMode},[data-list-mode='${listMode}']`).trigger("click");

                var someTabTriggerEl = document.querySelector(`[data-list-mode='${listMode}']`);
                if (someTabTriggerEl != null) {
                    var tab = new bootstrap.Tab(someTabTriggerEl);
                    tab.show();
                }

                if (mapView.isLoaded()) {
                    mapView.showPopup(el, true);
                }
            });

            $(this).trigger('mapReady');
            resolve();
        });

    }


    /* init google maps */
    public loadMap(): void {

        if (!this._isLoaded && !this._isLoading) {
            this._isLoading = true;
            this._initGooogleMapFunction();

            this.init().then(() => {

                this._isLoaded = true;
                this._isLoading = false;

                if (!this.onMapReady) return
                this.onMapReady();
            });
        } else {

            if (!this.onMapReady) return
            this.onMapReady();
        }
    }

    public async loadAsync(): Promise<MapView> {
        return new Promise<MapView>((resolve, reject) => {
            if (this._isLoaded) {
                resolve(this);
                return;
            }

            if (!this._isLoaded && !this._isLoading) {
                this._isLoading = true;
                try {
                    this._initGooogleMapFunction();
                } catch (e) {
                    reject(e);
                }

                this.init().then(() => {

                    this._isLoaded = true;
                    this._isLoading = false;

                    //if (!this.onMapReady) return
                    //this.onMapReady();
                    resolve(this);
                });

            } else {
                resolve(this);
            }
        });

    }

    /* init goolgle maps when container become visible */
    public async lazyLoad(): Promise<MapView> {


        return new Promise((resolve, reject) => {
            const instance = this;

            if (instance._isLoaded) {
                resolve(instance);
                return;
            }

            instance.one('map-ready', () => {
                resolve(instance);
            });

            var observer = new IntersectionObserver(function (entries) {
                // isIntersecting is true when element and viewport are overlapping
                // isIntersecting is false when element and viewport don't overlap
                if (entries[0].isIntersecting === true) {

                    if (!instance._isLoaded && !instance._isLoading) {
                        instance._isLoading = true;
                        instance._isLoaded = false;
                        instance._initGooogleMapFunction();
                        instance.init().then(() => {
                            instance._isLoading = false;
                            instance._isLoaded = true;
                            instance.emit('map-ready');
                        });

                        return;
                    } else {
                        instance.emit('map-ready');
                    }
                    observer.unobserve(entries[0].target);
                }
                //console.log('Element has just become visible in screen');
            }, { threshold: [0] });
            observer.observe(this._mapElement);
        });
    }

    //#endregion


    public clear(): MapView {
        this.clearEventListener("map-ready");
        this.clearMarkers();
        this.clearCache();
        return this;
    }


    public get markers(): google.maps.marker.AdvancedMarkerElement[] { return this._markers; }


    private printElement(elem: HTMLElement) {

        var mywindow = window.open('', 'PRINT', 'height=400,width=600');

        mywindow.document.write('<html><head><title>' + document.title + '</title>');
        mywindow.document.write('</head><body >');
        mywindow.document.write('<h1>' + document.title + '</h1>');
        mywindow.document.write(elem.innerHTML);
        mywindow.document.write('</body></html>');

        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/

        mywindow.onafterprint = () => {
            mywindow.close();
        };
        mywindow.print();



        return true;
    }

    public printMap() {

        return this.printElement(document.getElementById("map"));
    }

    public printRoute() {
        return this.printElement(document.getElementById("map-direction-content"));
    }

    public async fitView(el: HTMLElement) {
        const mapView = this;

        const { spherical } = await google.maps.importLibrary("geometry") as google.maps.GeometryLibrary;

        if (el == null && $('[data-toggle="map-view"]:checked').length > 0) {
            el = $('[data-toggle="map-view"]:checked')[0];
        }

        var maxDistance = 0;

        //if (el.dataset.mapView) mapView.selectedView = JSON.parse(el.dataset.mapView);             
        //if (el.dataset.displayPrice) mapView._displayPrice = JSON.parse(el.dataset.displayPrice);
        if (el.dataset.mapViewDistance) maxDistance = JSON.parse(el.dataset.mapViewDistance);

        $('[data-toggle="map-view"]').removeClass('active');

        mapView.setZoom(18);
        let bounds = new google.maps.LatLngBounds();

        var markers: google.maps.marker.AdvancedMarkerElement[] = mapView._map['markers'];

        markers.sort(function (a, b) {
            var distanceA = google.maps.geometry.spherical.computeDistanceBetween(mapView._options.center, a.position);
            var distanceB = google.maps.geometry.spherical.computeDistanceBetween(mapView._options.center, b.position);
            if (distanceA > distanceB) return 1;
            if (distanceA < distanceB) return -1;
            return 0;
        });

        let hotelsInBounds = [];

        markers.forEach(async m => {
            var model = m['model'] as Controls.GoogleMap.MarkerViewModel;
            if (model != null) {

                m.content = mapView.createMarkerElement(model);
                const distance = google.maps.geometry.spherical.computeDistanceBetween(mapView._options.center, m.position);

                if (maxDistance == 0 || distance < maxDistance) {
                    bounds.extend(m.position);
                    if (model.category == Controls.GoogleMap.MarkerCategories.Hotel) {
                        hotelsInBounds.push(m);
                    }
                }
            }

        });

        // if no hotel in bound add first nearest hotel in the bound
        if (hotelsInBounds.length == 0) {
            var firstHotelMarker = markers.find(m => (m['model'] as Controls.GoogleMap.MarkerViewModel).category == Controls.GoogleMap.MarkerCategories.Hotel);
            if (firstHotelMarker != null) {
                bounds.extend(firstHotelMarker.position);
            }
        }

        mapView.fitBounds(bounds);

        el.classList.add("active");

    }

    public getZoom(zoom: number) {
        return this._map.getZoom();
    }

    public setZoom(zoom: number) {
        this._map.setZoom(zoom);
    }

    public fitBounds(bounds?: google.maps.LatLngBounds | google.maps.LatLngBoundsLiteral) {

        if (bounds != null) {
            this._map.fitBounds(bounds);
        } else {
            this._map.fitBounds(this.getBounds());
        }
    }
    public toogleFullscreen() {

        if (document.fullscreenElement == null)
            this._mapElement.requestFullscreen();
        else
            document.exitFullscreen();
    }

    public async show(): Promise<void> {
        this.init();
        this._mapElement.style.display = '';
    }
    public async hide(): Promise<void> {
        this._mapElement.style.display = 'none';
    }

    public async toggle(): Promise<void> {
        if (this._mapElement.style.display == 'none') {
            this.show();
        } else {
            this.hide();
        }
    }


    public toggleView(el: HTMLElement) {
        this.loadMarkers(el.dataset.url, this._request);
    }

    public circleRadius(radius: number, color: string): google.maps.Circle {
        radius = Number(radius);
        if (this._radius == null) {
            this._radius = new google.maps.Circle({
                radius: radius, center: this._options.center,
                strokeColor: color,
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: color,
                fillOpacity: 0.35,
                map: this._map
            });
        } else {
            this._radius.setRadius(radius);
            this._radius.setMap(this._map);
        }

        const bounds = new google.maps.LatLngBounds();

        $.each(this._markers, function (index, m) {
            const gm = m as google.maps.marker.AdvancedMarkerElement;
            if (gm.position != null) {
                bounds.extend(gm.position);
            }
        });

        //this._map.panToBounds(bounds);
        this._map.fitBounds(this._radius.getBounds());

        return this._radius;
    }

    private delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }


    public async displayPopup(input: any, contentUrl: string, id: any, fitBounds: boolean): Promise<void> {

        this._infoWindow.close();
        this._infoWindow.setContent(null);
        this._infoWindow.setHeaderContent(null);

        const mapView = this;

        // input htmlelement : find marker in array.
        let marker: google.maps.marker.AdvancedMarkerElement;
        if (input instanceof google.maps.marker.AdvancedMarkerElement) {
            marker = input as google.maps.marker.AdvancedMarkerElement;
        } else if (input instanceof HTMLElement) {

            const hotelId = $(input).data("hotelId");
            const bookingComId = $(input).data("hotelBookingcomId");
            const markers = this._markers as google.maps.marker.AdvancedMarkerElement[];

            if (hotelId) {
                marker = markers.find(pm => pm["model"].selector == `[data-hotel-id='${hotelId}']`);

            } else if (bookingComId) {
                marker = markers.find(pm => pm["model"].selector == `[data-hotel-bookingcom-id='${bookingComId}']`);
            } else {
                return;
            }

        } else {
            return;
        }

        const item: Controls.GoogleMap.MarkerViewModel = marker["model"];


        if (fitBounds && marker.map == null) {

            this._map.panTo(marker.position);

            // si map null on est dans un cluster 
            while (marker.map == null) {

                // on zoom pour faire sortir le marker du cluster 
                this._map.setZoom(this._map.getZoom() + 1);

                // on attend que la mise a jour du clusterer
                await new Promise(resolve => setTimeout(resolve, 360));
            }
        }



        if (item.category == Controls.GoogleMap.MarkerCategories.None) {
            return;
        }

        if (item.category == Controls.GoogleMap.MarkerCategories.POI || item.category == Controls.GoogleMap.MarkerCategories.EventLocation) {

            const divMarkerTitle = document.createElement("div");
            divMarkerTitle.innerHTML = "<h5 class='mb-0'>" + item.title + "</h5>";
            this._infoWindow.setHeaderContent(divMarkerTitle);
            this._infoWindow.open(this._map, marker);

            return;

        }

        const divMarkerWindow = document.createElement("div");
        const spinner = document.createElement("div");

        divMarkerWindow.className = "marker-infoWindow";
        spinner.className = 'marker-infoWindow-loader';
        spinner.innerHTML = `<div class="spinner-border" role="status"><span class="visually-hidden">${this._options.local.loading}</span></div>`;

        divMarkerWindow.appendChild(spinner);

        this._infoWindow.setContent(divMarkerWindow);

        this._infoWindow.setOptions({
            disableAutoPan: false
        });

        $(marker.element).addClass("active");


        if (id) {
            $.post(contentUrl, { id })
                .done(function (response) {
                    divMarkerWindow.outerHTML = response;
                }).fail(function (xhr, status, error) {
                    divMarkerWindow.innerHTML = `<div class="text-center d-grid text-danger"><i class="far fa-exclamation-triangle fa-2x"></i><br/>${mapView._options.local.errors.errorLoadingHotel}</div>`;
                }).always(function () {
                    spinner.style.display = 'none';

                });

        } else {
            divMarkerWindow.className = "marker-title";
            divMarkerWindow.innerHTML = item.title;
        }

        this._infoWindow.open(this._map, marker);
    }

    public async showPopup(input: google.maps.marker.AdvancedMarkerElement | HTMLElement, fitBounds: boolean = false): Promise<void> {

        this._infoWindow.close();
        this._infoWindow.setContent(null);
        this._infoWindow.setHeaderContent(null);

        const infoWindow = this._infoWindow;

        const mapView = this;

        // input htmlelement : find marker in array.
        let marker: google.maps.marker.AdvancedMarkerElement;
        if (input instanceof google.maps.marker.AdvancedMarkerElement) {
            marker = input as google.maps.marker.AdvancedMarkerElement;
        } else if (input instanceof HTMLElement) {

            const hotelId = $(input).data("id");
            const bookingComId = $(input).data("hotelBookingcomId");
            const markers = this._markers as google.maps.marker.AdvancedMarkerElement[];

            if (hotelId) {
                marker = markers.find(pm => pm["model"].id == hotelId);
            } else {
                return;
            }

        } else {
            return;
        }

        const item: Controls.GoogleMap.SimpleMarker = marker["model"];


        if (fitBounds && marker.map == null) {

            this._map.panTo(marker.position);

            // si map null on est dans un cluster 
            while (marker.map == null) {

                // on zoom pour faire sortir le marker du cluster 
                this._map.setZoom(this._map.getZoom() + 1);

                // on attend que la mise a jour du clusterer
                await new Promise(resolve => setTimeout(resolve, 360));
            }
        }


        //if (item.category == Controls.GoogleMap.MarkerCategories.None) {
        //    return;
        //}

        //if (item.category == Controls.GoogleMap.MarkerCategories.POI || item.category == Controls.GoogleMap.MarkerCategories.EventLocation) {

        //    const divMarkerTitle = document.createElement("div");
        //    divMarkerTitle.innerHTML = "<h5 class='mb-0'>" + item.title + "</h5>";
        //    this._infoWindow.setHeaderContent(divMarkerTitle);
        //    this._infoWindow.open(this._map, marker);

        //    return;

        //}

        const divMarkerWindow = document.createElement("div");
        const spinner = document.createElement("div");

        divMarkerWindow.className = "marker-infoWindow";
        spinner.className = 'marker-infoWindow-loader';
        spinner.innerHTML = `<div class="spinner-border" role="status"><span class="visually-hidden">${this._options.local.loading}</span></div>`;

        divMarkerWindow.appendChild(spinner);

        infoWindow.setContent(divMarkerWindow);

        infoWindow.setOptions({
            disableAutoPan: false,            
        });

        $(marker.element).addClass("active");
        

        if (item.contentUrl != null) {
            $.post(item.contentUrl, { id: item.id })
                .done(function (response) {
                    divMarkerWindow.outerHTML = response;
                }).fail(function (xhr, status, error) {
                    divMarkerWindow.outerHTML = `<div class="text-center d-grid text-danger"><i class="far fa-exclamation-triangle fa-2x"></i><br/>${mapView._options.local.errors.errorLoadingHotel}</div>`;
                }).always(function () {
                    spinner.style.display = 'none';

                });

        } else {
            divMarkerWindow.className = "marker-title";
            divMarkerWindow.innerHTML = item.title;
        }

        infoWindow.open({ anchor: marker, map: this._map, shouldFocus: true });
         
    }


    public checkView() {
        var selectedView = $('[data-toggle="map-view"]:checked');
        const el = selectedView[0];

        $('[data-map-view="' + el.id + '"]').css('display', '');

        switch (selectedView.val()) {

            case 'list':
                this.fitView(el);
                break;

            case 'direction':


                this.calcDirection();

                break;

            case 'nearby':
                const selectedRadiusElement = $('input[name="nearby"]:checked');
                const selectedRadius: number = selectedRadiusElement.val() as number;
                this.circleRadius(selectedRadius, 'red');
                break;

            case 'similars':
                this.showCircleSimilar();
                break;
        }

    }


    public async switchRoutes(el?: HTMLSelectElement): Promise<void> {

        if (el == null) {

            const start = $("#mapDirectionStart").find('option:selected').val();
            const end = $("#mapDirectionEnd").find('option:selected').val();


            $("#mapDirectionStart").find(`option[value="${end}"]`).prop("selected", true);
            $("#mapDirectionEnd").find(`option[value="${start}"]`).prop("selected", true);
        }

        this.calcDirection();
    }

    public setRouteIndex(el: HTMLSelectElement) {
        this.directionsRenderer.setRouteIndex(el.selectedIndex);
    }

    public calculateAndDisplayRoute(start: Controls.GoogleMap.MarkerViewModel | any, end: Controls.GoogleMap.MarkerViewModel, travelMode: google.maps.TravelMode) {
        const mapView = this;

        $('<div class="d-flex w-100 justify-content-center align-items-center my-3 overflow-hidden"><div class="spinner-border" role="status"><span class= "visually-hidden" > Loading...</span></div></div>').appendTo($('#map-direction-content').empty());

        function overrideDirectionsPOI(iconStart, iconEnd) {
            $("button[data-leg-index='0']").find('img[jstcache]').attr('src', iconStart).css('width', '32px').css('height', 'auto');
            $("button[data-leg-index='1']").find('img[jstcache]').attr('src', iconEnd).css('width', '32px').css('height', 'auto');
        }

        const unit = globals.iif(this._options.distanceUnit == Controls.GoogleMap.DistanceUnit.km, google.maps.UnitSystem.METRIC, google.maps.UnitSystem.IMPERIAL);
        const geocoder = new google.maps.Geocoder();

        mapView.directionsService
            .route({
                origin: start.position,
                destination: end.position,
                provideRouteAlternatives: true,
                //waypoints: waypts,
                //waypoints: waypts,
                //optimizeWaypoints: true,   
                unitSystem: unit,
                language: document.documentElement.lang,
                avoidFerries: false,
                avoidHighways: false,
                avoidTolls: false,


                travelMode: travelMode,
            })
            .then((response) => {

                $('#map-direction-content').empty();
                mapView.directionsRenderer.setDirections(response);

                setTimeout(function () {
                    overrideDirectionsPOI(start.icon.url, end.icon.url);
                    $('#map-direction-panel,.btn-collapse-map-direction').css('display', '');

                    $('#map-direction-panel').removeAttr('data-select2-id');
                }, 1);


                geocoder.geocode({ location: start.position }, function (results, status) {
                    $('#mapDirectionStart>option:selected').data('address', results[0].formatted_address);
                });

            })
            .catch((e) => {

                $('<span class="map-direction-error">' + e + '</span>').appendTo($("#map-direction-content").empty());
            });



        function makeMarker(position, icon, title) {
            new google.maps.marker.AdvancedMarkerElement({
                position: position,
                map: mapView._map,
                content: icon,
                title: title
            });
        }

    }

    public calcDirection() {
        const mapView = this;
        //const start = this._map['markers'][0];
        //const end = this._map['markers'][1];
        const start = $("#mapDirectionStart").find('option:selected').val();
        const end = $("#mapDirectionEnd").find('option:selected').val();
        const markers = this._map['markers'] as google.maps.marker.AdvancedMarkerElement[];
        const travelMode = google.maps.TravelMode[$('#map-direction-travelMode>li>input:checked').val() as keyof typeof google.maps.TravelMode] as google.maps.TravelMode;
        var geocoder = new google.maps.Geocoder;


        var startMarker = markers.find((v, i, r) => v['model'].key == start);
        var endMarker = markers.find((v, i, r) => v['model'].key == end);
        if (start != undefined && end != undefined) {



            geocoder.geocode({ location: endMarker.position }, function (results, status) {
                $('#mapDirectionEnd>option:selected').data('address', results[0].formatted_address);
            });

            if (start == 0) {

                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(function (position) {

                        var address = 'ma position';


                        const pos: google.maps.LatLngLiteral = {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude
                        }


                        const maPosition: Controls.GoogleMap.MarkerViewModel = {
                            key: '0',
                            selector: '',
                            views: 0,
                            category: Controls.GoogleMap.MarkerCategories.NavPosition,
                            title: address, allowArrival: true, allowDeparture: false, allowCluster: false,
                            position: pos,
                            icon: {
                                url: '/images/icons/map/marker_pink.png', size: { height: 32, width: 32 }, className: ''
                            }
                        };

                        mapView.calculateAndDisplayRoute(maPosition, endMarker['model'], travelMode);
                        var bounds = new google.maps.LatLngBounds(maPosition.position).extend(endMarker.position);
                        mapView._map.fitBounds(bounds);
                        mapView._map.panToBounds(bounds);


                        mapView.addMarker(maPosition);


                    }, err => $('<span class="map-direction-error">' + err.message + '</span>').appendTo($("#map-direction-content").empty()));
                    return;
                }
            }

            this.calculateAndDisplayRoute(startMarker['model'], endMarker['model'], travelMode);
            var bounds = new google.maps.LatLngBounds(startMarker.position).extend(endMarker.position);
            this._map.fitBounds(bounds);
            this._map.panToBounds(bounds);
        }
    }



    /// #region Markers 

    private createMarkerElement(item: Controls.GoogleMap.MarkerViewModel): HTMLElement {

        const displayPrice = $('[data-toggle="map-view"]:checked').data('displayPrice');

        if (item != null && item.icon != null && item.icon.template != undefined) {
            // templating ... 
            let temp = document.getElementById(item.icon.template) as HTMLTemplateElement;
            let e = temp.content.cloneNode(true) as HTMLElement;

            if (e != null) {
                //var r = interpolate(temp.innerHTML, item);

                if (item.category == Controls.GoogleMap.MarkerCategories.Hotel) {
                    $(e).find(".marker-container").attr('data-hotel-id', item.key).addClass(item.className);
                    if (item.displayPrice) {
                        $(e).find(".marker-price").html(item.displayPrice);
                    }
                    else {
                        $(e).find(".marker-price").html("");
                    }

                    if (item.isYouthOffer) {
                        $(e).find(".fa-suitcase").toggleClass("d-none");
                    } else {
                        $(e).find(".marker-stars").addClass(item.icon.className);
                    }
                }

                if (item.category == Controls.GoogleMap.MarkerCategories.POI) {
                    $(e).find("img").attr('src', item.icon.url);
                }

                return e;
            }
        }

        // pas de template on crée un element html
        const containerDiv = document.createElement('div');
        containerDiv.className = 'marker-container';
        const att = document.createAttribute('data-hotel-id');
        att.value = item.key;
        containerDiv.attributes.setNamedItem(att);
        const div = document.createElement('div');
        div.className = 'marker-price ';
        div.innerHTML = item.displayPrice;

        var starDiv = document.createElement("div");
        starDiv.className = item.icon.className;


        //containerDiv.appendChild(img);
        containerDiv.appendChild(div);
        containerDiv.appendChild(starDiv);

        if (item.className != undefined)
            containerDiv.className += (' ' + item.className);

        return containerDiv;
    }

    public createMarker(item: Controls.GoogleMap.MarkerViewModel): any {
        const mapView = this;
        const map = this._map;

        let ValueZIndex = 1;
        if (/hotel-marker/.test(item.className)) {
            ValueZIndex = 2; // Hôtels prioritaires
        }

        const marker = new google.maps.marker.AdvancedMarkerElement({
            map: map,
            position: item.position,
            title: item.title,
            gmpDraggable: false,
            content: this.createMarkerElement(item),
            gmpClickable: true,
            collisionBehavior: google.maps.CollisionBehavior.REQUIRED,

            zIndex: ValueZIndex,
        });
        marker['model'] = item;
        marker.addListener('click', ({ domEvent, latLng }) => {
            const { target } = domEvent;
            mapView.showPopup(marker);
        });
        return marker;
    }

    public get defaultMarker(): HTMLElement {

        const icon = document.createElement('div');

        icon.className = this.defaultMarkerClass;
        
        const img = document.createElement('img');
        img.src = this.defaultMarkerIcon;
        icon.appendChild(img);

        return icon;
    }
    public async addSimpleMarkers(items: Controls.GoogleMap.SimpleMarker[]): Promise<void> {

        return new Promise((resolve, reject) => {
            return this.lazyLoad().then(async (mapView) => {
                const map = mapView._map;
                const { AdvancedMarkerElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;

                const markers = mapView._markers;
                var cluster: google.maps.marker.AdvancedMarkerElement[] = [];

                items.forEach((item, index) => {

                    item.content = item.content ?? this.defaultMarker;

                    const marker = new google.maps.marker.AdvancedMarkerElement({
                        map: map,
                        position: item.position,
                        gmpDraggable: false,
                        gmpClickable: true,
                        collisionBehavior: google.maps.CollisionBehavior.REQUIRED,
                        title: item.title,
                        content: item.content,
                        zIndex: 1,
                    });

                    //const marker = mapView.fnCreateMarker(item, map);

                    marker['model'] = item;

                    $(marker).prop('model', item);


                    marker.addListener('click', ({ domEvent, latLng }) => {
                        const { target } = domEvent;

                        mapView.displayPopup(marker, item.contentUrl, item.id, true);

                    });
                    markers.push(marker);

                    if (item.allowCluster) {
                        cluster.push(marker);
                    }

                    this.makeCluster(cluster);

                });

                mapView.fitBounds();
                resolve();
            });

        });





    }

    private makeCluster(markers: Marker[]) {
        this._clusterer?.clearMarkers();
        var map = this._map;

        this._clusterer = new MarkerClusterer({
            map, markers, renderer: {
                render: function ({ count, position }, stats, map) {
                    // change color if this cluster has more markers than the mean cluster
                    const color = count > Math.max(10, stats.clusters.markers.mean) ? "#ff0000" : "white";
                    const fcolor = count > Math.max(10, stats.clusters.markers.mean) ? "#ffffff" : "#000000";

                    const id = crypto.randomUUID();

                    const html = `<div class="marker-cluster" id="${id}">
                                                <span class="marker-cluster-counter">${count}</span><br/>
                                                <span class="marker-cluster-category " style="white-space:nowrap">hotels</span>
                                            </div>`;
                    const title = `${count} @clusterTitle`,
                        // adjust zIndex to be above other markers
                        zIndex = 3;//Number(google.maps.Marker.MAX_ZINDEX) + count;

                    const clusterOptions = {
                        map,
                        position,
                        zIndex,
                        title,
                        content: $(html)[0],
                    };
                    const clusterMarker = new google.maps.marker.AdvancedMarkerElement(clusterOptions);

                    $(document)
                        .on('mouseenter', `#${id}`, () => clusterMarker.zIndex = 99999999999999)
                        .on('mouseleave', `#${id}`, () => clusterMarker.zIndex = zIndex);

                    return clusterMarker;
                }
            }
        })
    }

    public async addSimpleMarker(item: Controls.GoogleMap.SimpleMarker): Promise<void> {
        //const { AdvancedMarkerElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;
        return new Promise(async (resolve, reject) => {

            return this.lazyLoad().then(async (mapView) => {

                const { AdvancedMarkerElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;
                const map = mapView._map;
                const markers = mapView._markers;

                //const img = document.createElement('img');
                //img.src = item.icon;// 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png';

                //const glyphSvgPinElement = new google.maps.marker.PinElement({
                //    glyph: item.content,
                //});

                item.content = item.content ?? this.defaultMarker;
                
                //const markerIcon = document.createElement('img');
                //markerIcon.src = item.content ?? window['defaultMarkerIcon'];// 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png';

                const marker = new google.maps.marker.AdvancedMarkerElement({
                    map: map,
                    position: item.position,
                    gmpDraggable: false,
                    gmpClickable: true,
                    collisionBehavior: google.maps.CollisionBehavior.REQUIRED,
                    title: item.title,
                    content: item.content,
                    zIndex: Number(google.maps.Marker.MAX_ZINDEX) + 1000
                });

                marker['model'] = item;

                $(marker).prop('model', item);


                marker.addListener('click', ({ domEvent, latLng }) => {
                    const { target } = domEvent;
                    mapView.showPopup(marker);

                });
                markers.push(marker);

                if (item.allowCluster) {
                    mapView._clusterer.addMarker(marker);
                }
                resolve();
            });
        });
    }
    public async addSimpleMarkerAsync(item: Controls.GoogleMap.SimpleMarker): Promise<void> {
        const mapView = this;
        const markers = this._markers;
        //const { Map, InfoWindow } = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;
        //const { AdvancedMarkerElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;
        this.lazyLoad().then(async function () {

            const { AdvancedMarkerElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;

            const map = mapView._map;

            //const img = document.createElement('img');
            //img.src = item.icon;// 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png';

            //const glyphSvgPinElement = new google.maps.marker.PinElement({
            //    glyph: item.content,
            //});

            item.content = item.content ?? mapView.defaultMarker;

            const marker = new google.maps.marker.AdvancedMarkerElement({
                map: map,
                position: item.position,
                gmpDraggable: false,
                gmpClickable: true,
                collisionBehavior: google.maps.CollisionBehavior.REQUIRED,
                title: item.title,
                content: item.content,
                zIndex: 1,
            });

            marker['model'] = item;

            $(marker).prop('model', item);


            marker.addListener('click', ({ domEvent, latLng }) => {
                const { target } = domEvent;
                mapView.showPopup(marker);

            });
            markers.push(marker);
            if (item.allowCluster) {
                mapView._clusterer.addMarker(marker);
            }
        });
    }

    public async addMarker(item: Controls.GoogleMap.MarkerViewModel): Promise<google.maps.marker.AdvancedMarkerElement> {

        const { AdvancedMarkerElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;

        const mapView = this;
        const map = this._map;


        const marker = new google.maps.marker.AdvancedMarkerElement({
            map: map,
            position: item.position,
            title: item.title,
            gmpDraggable: false,
            content: this.createMarkerElement(item),
            gmpClickable: true,
            collisionBehavior: google.maps.CollisionBehavior.REQUIRED,

            zIndex: 1,
        });

        marker['model'] = item;

        $(marker).prop('model', item);

        marker.addListener('click', ({ domEvent, latLng }) => {
            const { target } = domEvent;
            mapView.showPopup(marker);

        });

        return marker;
    }


    public async findMarker(key: string): Promise<google.maps.marker.AdvancedMarkerElement> {
        return new Promise((resolve, reject) => {
            const markers = this._markers;

            var marker = markers.find(v => {
                const item = v['model'] as Controls.GoogleMap.SimpleMarker;
                return item.id == key;
            })
            if (marker) {
                resolve(marker);
            } else {
                reject("not found");
            }
        });
    }

    public clearMarkers(): MapView {
        const markers = this._markers;
        const clusterer = this._clusterer;
        console.debug("clearing markers");

        if (this._map == null) {

            if (clusterer != null) {
                clusterer.clearMarkers();
            }

            this._markers = new Array();
            return this;
        }



        if (clusterer != null) {
            clusterer.clearMarkers();
        }

        for (var i = 0; i < markers.length; i++) {
            var el = markers[i] as google.maps.marker.AdvancedMarkerElement;
            el.map = null;
        }


        this._markers = new Array();
        if (clusterer != null) {
            clusterer.setMap(this._map);//.MarkerClusterer(this._map, new Array());
        }

        return this;
    }
    /// #endregion 



    private buildKey(url: string, request: any) {
        const storageKey = this._options.storageKey;
        return JSON.stringify({ storageKey, url, request });
    }

    // get from session (if the value expired it is destroyed)
    private sessionGet(key) {
        let stringValue = this._markersStore.getItem(key)
        if (stringValue !== null) {
            let value = JSON.parse(stringValue)
            let expirationDate = new Date(value.expirationDate)
            if (expirationDate > new Date()) {
                return value.value
            } else {
                this._markersStore.removeItem(key)
            }
        }
        return null
    }

    // add into session
    private sessionSet(key, value, expirationInMin = 10) {
        let expirationDate = new Date(new Date().getTime() + (60000 * expirationInMin))
        let newValue = {
            value: value,
            expirationDate: expirationDate.toISOString()
        }
        this._markersStore.setItem(key, JSON.stringify(newValue))
    }


    private getCachedMarkers(url: string, request: any) {

        const key = this.buildKey(url, request);

        //var value = $(this._markers).prop(key);
        //if (value != undefined) {
        //    return value;
        //}

        if (this._markersStore != undefined) {
            var result = this.sessionGet(key);
            if (result != undefined) {
                return JSON.parse(result);
            }
        }
        return undefined;
    }

    private setCachedMarkers(url: string, request: any, response: any) {
        const key = this.buildKey(url, request);
        //$(this._markers).prop(key, response);

        if (this._markersStore != undefined) {
            try {// sometime storage is full 
                this.sessionSet(key, JSON.stringify(response));
            } catch {
                new Promise(() => this._markersStore.clear()).then(() => {
                    this.sessionSet(key, JSON.stringify(response));
                });
            }
        }
    }

    private clearCache() {
        this._markersStore?.clear();
    }

    public async loadMarkers(url: string, request: any, callBack?: Function): Promise<MapView> {

        const { InfoWindow } = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;
        const { AdvancedMarkerElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;


        const mapView: MapView = this;
        const map: google.maps.Map = mapView._map;
        const useCluster: boolean = mapView._clusterer != null;
        mapView._request = request;
        $('#defaultmap-loader').show();
        $('[data-map-view]').css('display', 'none');

        this._map['similars']?.setMap(null);

        var cache = this;


        $('#mapDirectionStart, #mapDirectionEnd').empty();

        if (this._radius != null)
            this._radius.setMap(null);

        this.clearMarkers();

        let markersByUrl = cache.getCachedMarkers(url, request);

        if (markersByUrl != undefined) {//(this._markers[url] != undefined) {

            loadResponse(url, request, markersByUrl);// this._markers[url]);

            finalize();

            return this;
        }

        await $.post(url, request)
            .done(function (response) {

                loadResponse(url, request, response);
            })
            .fail(function (xhr, status, error) {

                $('#map-error>div>span').html(mapView._options.local.errors.errorLoadingData);
                $('#map-error>div>span.error-details').html(error);
                $('#map-error>div>button').on('click', function () {
                    $('#map-error').hide();
                    mapView.loadMarkers(url, request, callBack);
                });
                $('#map-error').show();

            })
            .always(function () {
                finalize();
            });


        function finalize() {

            $('#defaultmap-loader').hide();
            if (callBack !== undefined) {
                callBack();
            }

            $(document).trigger("map:loaded");
        }



        function loadResponse(url, request, response) {
            //mapView._markers[url] = response;

            mapView.setCachedMarkers(url, request, response);

            const clusterMarkers: google.maps.marker.AdvancedMarkerElement[] = [];
            const allowCluster = response.allowCluster;
            const center = mapView._options.center;


            const carouselInner = $('#map-hotels-slider>div.carousel-inner');
            const templateItem = carouselInner.find('.carousel-item.active');

            var template = templateItem.clone(true)[0];


            let firstLoaded = false;
            let hotelsSliders = [];

            response.markers.forEach((item: Controls.GoogleMap.MarkerViewModel, index) => {

                const marker = mapView.createMarker(item);
                const hotelSelector = `[data-hotel-id="${item.key}"]`;
                const markerSelector = `.marker-container[data-hotel-id="${item.key}"]`;

                map['markers'].push(marker);

                if (allowCluster && item.allowCluster) {
                    clusterMarkers.push(marker);
                }


                if (item.category == Controls.GoogleMap.MarkerCategories.Hotel && mapView._options.sliderUrl != null && item.infoWindow != null) {

                    if (mapView._options.displayHotelsSliders) {

                        var carouselItem: HTMLElement;

                        if (!firstLoaded) {
                            carouselItem = templateItem[0] as HTMLElement;
                            loadSliderItem(carouselItem, request.searchRequest, item.infoWindow.hotelID);
                            firstLoaded = true;
                        } else {
                            carouselItem = template.cloneNode(true) as HTMLElement;
                            $(carouselItem).removeClass('active');
                            $(carouselItem).appendTo($('#map-hotels-slider>div.carousel-inner'));
                            var observer = new IntersectionObserver(function (entries) {
                                if (entries[0].isIntersecting === true) {
                                    loadSliderItem(carouselItem, request.searchRequest, item.infoWindow.hotelID);
                                }
                            }, { threshold: [0] });
                            observer.observe(carouselItem);
                        }
                        hotelsSliders.push(carouselItem);
                    }
                }

                function loadSliderItem(carouselItem, req, hotelId) {

                    $.post(mapView._options.sliderUrl, { searchRequest: req, hotelId: hotelId })
                        .done(r => {

                            $(carouselItem).prop('dataItem', item);
                            $(r).appendTo($(carouselItem).empty());

                        })
                        .fail(r => {
                            var statusText = r.statusText;

                            if (r.status == 404) {
                                statusText = 'hotel not found';
                            }
                            if (r.status == 500) {
                                statusText = 'internal server error';
                            }

                            $(carouselItem).find('.error').text(statusText);
                            $(carouselItem).find('.error-detail').text(r.responseText);
                            $(carouselItem).find('.row-error').css('display', 'flex');
                            $(carouselItem).find('.hotel-detail').css('display', 'none');
                        });

                }

                function selectMarker() {

                    marker.collisionBehavior = google.maps.CollisionBehavior.REQUIRED;
                    marker.zIndex = 999999999999;
                    //var bound = new google.maps.LatLngBounds(marker.position).extend(center);
                    //map.fitBounds(bound);
                    //map.panToBounds(bound);
                    marker.selected = true;

                    $(marker.content).parent().find('.marker-container').addClass('active');
                }

                function unselectMarker() {
                    marker.collisionBehavior = google.maps.CollisionBehavior.REQUIRED;
                    marker.zIndex = item.zIndex;
                    $(marker.content).parent().find('.marker-container').removeClass('active');
                    marker.selected = false;
                }


                // marker hover
                $(document)
                    .on('mouseenter', markerSelector, () => marker.zIndex = 999999999999)
                    .on('mouseleave', markerSelector, () => marker.zIndex = item.zIndex);

                /* list:hover */
                if (item.selector != "") {
                    $(document)
                        .on('mouseenter', item.selector, selectMarker)
                        .on('mouseleave', item.selector, unselectMarker);
                }

                let icon = item.icon.url;
                if (item.category == Controls.GoogleMap.MarkerCategories.Hotel) {
                    icon = `/images/icons/map/hotel.svg`;
                }
                if (item.allowArrival) {
                    $('#mapDirectionStart')
                        .append($(`<option value='${item.key}' >${marker.title}</option>`).attr('data-icon-url', icon).attr('data-icon-class-name', item.icon.className).attr('data-address', marker.title));
                }
                if (item.allowDeparture) {
                    $('#mapDirectionEnd')
                        .append($(`<option value='${item.key}' >${marker.title}</option>`).attr('data-icon-url', icon).attr('data-icon-class-name', item.icon.className).attr('data-address', marker.title));
                }


            });

            if (hotelsSliders.length == 0) {

                $('#map-hotels-slider').css('visibility', 'collapse');
                //templateItem.find('.error').text('0 hotel found').removeClass('text-warning');                
                //templateItem.find('.error-detail').text('no hotel found');
                //templateItem.find('.row-error').css('display', 'flex');
                //templateItem.find('.hotel-detail').css('display', 'none');
            } else {
                $('#map-hotels-slider').css('visiblity', 'visible');
            }

            if (response.markers.length > 1) {
                const start = response.markers[1];
                if (start != undefined)
                    $("#mapDirectionStart").find(`option[value="${start.key}"]`).prop("selected", true);

                const end = response.markers[0];
                if (end != undefined)
                    $("#mapDirectionEnd").find(`option[value="${end.key}"]`).prop("selected", true);

                if (allowCluster && mapView._clusterer != null) {
                    mapView._clusterer.addMarkers(clusterMarkers);
                }

                // insert detect ma position
                $('#mapDirectionStart')
                    .append($(`<option value='0' >${mapView._local.myLocation}</option>`).attr('data-icon-url', '/images/icons/map/marker_pink.png').attr('data-icon-class-name', 'position'));

            }

            mapView.checkView();


        }

    }

    public getBounds(): google.maps.LatLngBounds {
        const bounds = new google.maps.LatLngBounds();
        this._markers.forEach(m => bounds.extend(m.position));
        return bounds;
    }


    public showCircleSimilar() {

        const congressPosition = this._markers[0].position;
        const hotelPosition = this._markers[1].position;

        const distanceSimilar = distanceFromPosition(congressPosition.lat, congressPosition.lng, hotelPosition.lat, hotelPosition.lng);

        const distanceFrom = distanceSimilar - (distanceSimilar * 20 / 100);
        const distanceTo = distanceSimilar + (distanceSimilar * 20 / 100);

        const donut = new google.maps.Polygon({
            paths: [drawCircleSimilar(congressPosition, distanceTo, 1),
            drawCircleSimilar(congressPosition, distanceFrom, -1)],
            strokeOpacity: 0,
            fillColor: "#f67a97",
            fillOpacity: 0.3,
            map: this._map, geodesic: true
        });


        this._map['similars'] = donut;

        const bounds = new google.maps.LatLngBounds();
        donut.getPath().forEach(c => bounds.extend(c));

        this._map.fitBounds(bounds);


        function distanceFromPosition(lat1, lon1, lat2, lon2) {
            // 0.1% error from google.maps.geometry.spherical.computeDistanceBetween
            var R = 6371000; // m
            var dLat = (lat2 - lat1) * Math.PI / 180;
            var dLon = (lon2 - lon1) * Math.PI / 180;
            lat1 = lat1 * Math.PI / 180;
            lat2 = lat2 * Math.PI / 180;

            var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            var d = R * c;
            return d;
        }
        function drawCircleSimilar(point, radius, dir) {
            var d2r = Math.PI / 180;   // degrees to radians 
            var r2d = 180 / Math.PI;   // radians to degrees 
            var earthsradius = 6371000; // m

            var points = 32;

            // find the radius in lat/lon 
            var rlat = (radius / earthsradius) * r2d;
            var rlng = rlat / Math.cos(point.lat * d2r);

            var extp = new Array();
            if (dir == 1) {
                var start = 0;
                var end = points + 1;
            } else {
                var start = points + 1;
                var end = 0;
            }

            for (var i = start; (dir == 1 ? i < end : i > end); i = i + dir) {
                var theta = Math.PI * (i / (points / 2));
                const ey = point.lng + (rlng * Math.cos(theta)); // center a + radius x * cos(theta) 
                const ex = point.lat + (rlat * Math.sin(theta)); // center b + radius y * sin(theta) 
                extp.push(new google.maps.LatLng(ex, ey));
            }
            return extp;
        }
    }

    public async addMarkers(markers: Controls.GoogleMap.MarkerViewModel[], allowCluster: boolean): Promise<void> {

        const { AdvancedMarkerElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;

        const mapView = this;
        const map = this._map;


        const clusterMarkers: google.maps.marker.AdvancedMarkerElement[] = [];

        const center = this._options.center;

        const carouselInner = $('#map-hotels-slider>div.carousel-inner');
        const templateItem = carouselInner.find('.carousel-item.active');

        var template = templateItem.clone(true)[0];


        let firstLoaded = false;
        let hotelsSliders = [];

        markers.forEach((item: Controls.GoogleMap.MarkerViewModel, index) => {

            const marker = mapView.createMarker(item);
            const hotelSelector = `[data-hotel-id="${item.key}"]`;
            const markerSelector = `.marker-container[data-hotel-id="${item.key}"]`;

            mapView._markers.push(marker);

            if (allowCluster && item.allowCluster) {
                clusterMarkers.push(marker);
            }
            /*

            if (item.category == Controls.GoogleMap.MarkerCategories.Hotel && mapView._options.sliderUrl != null && item.infoWindow != null) {

                if (mapView._options.displayHotelsSliders) {

                    var carouselItem: HTMLElement;

                    if (!firstLoaded) {
                        carouselItem = templateItem[0] as HTMLElement;
                        loadSliderItem(carouselItem, request.searchRequest, item.infoWindow.hotelID);
                        firstLoaded = true;
                    } else {
                        carouselItem = template.cloneNode(true) as HTMLElement;
                        $(carouselItem).removeClass('active');
                        $(carouselItem).appendTo($('#map-hotels-slider>div.carousel-inner'));
                        var observer = new IntersectionObserver(function (entries) {
                            if (entries[0].isIntersecting === true) {
                                loadSliderItem(carouselItem, request.searchRequest, item.infoWindow.hotelID);
                            }
                        }, { threshold: [0] });
                        observer.observe(carouselItem);
                    }
                    hotelsSliders.push(carouselItem);
                }
            }

            function loadSliderItem(carouselItem, req, hotelId) {

                $.post(mapView._options.sliderUrl, { searchRequest: req, hotelId: hotelId })
                    .done(r => {

                        $(carouselItem).prop('dataItem', item);
                        $(r).appendTo($(carouselItem).empty());

                    })
                    .fail(r => {
                        var statusText = r.statusText;

                        if (r.status == 404) {
                            statusText = 'hotel not found';
                        }
                        if (r.status == 500) {
                            statusText = 'internal server error';
                        }

                        $(carouselItem).find('.error').text(statusText);
                        $(carouselItem).find('.error-detail').text(r.responseText);
                        $(carouselItem).find('.row-error').css('display', 'flex');
                        $(carouselItem).find('.hotel-detail').css('display', 'none');
                    });

            }
            */
            function selectMarker() {

                marker.collisionBehavior = google.maps.CollisionBehavior.REQUIRED;
                marker.zIndex = 999999999999;
                //var bound = new google.maps.LatLngBounds(marker.position).extend(center);
                //map.fitBounds(bound);
                //map.panToBounds(bound);
                marker.selected = true;

                $(marker.content).parent().find('.marker-container').addClass('active');
            }

            function unselectMarker() {
                marker.collisionBehavior = google.maps.CollisionBehavior.REQUIRED;
                marker.zIndex = item.zIndex;
                $(marker.content).parent().find('.marker-container').removeClass('active');
                marker.selected = false;
            }


            // marker hover
            $(document)
                .on('mouseenter', markerSelector, () => marker.zIndex = 999999999999)
                .on('mouseleave', markerSelector, () => marker.zIndex = item.zIndex);

            /* list:hover */
            if (item.selector != "") {
                $(document)
                    .on('mouseenter', item.selector, selectMarker)
                    .on('mouseleave', item.selector, unselectMarker);
            }

            let icon = item.icon.url;
            if (item.category == Controls.GoogleMap.MarkerCategories.Hotel) {
                icon = `/images/icons/map/hotel.svg`;
            }
            if (item.allowArrival) {
                $('#mapDirectionStart')
                    .append($(`<option value='${item.key}' >${marker.title}</option>`).attr('data-icon-url', icon).attr('data-icon-class-name', item.icon.className).attr('data-address', marker.title));
            }
            if (item.allowDeparture) {
                $('#mapDirectionEnd')
                    .append($(`<option value='${item.key}' >${marker.title}</option>`).attr('data-icon-url', icon).attr('data-icon-class-name', item.icon.className).attr('data-address', marker.title));
            }


        });

        if (hotelsSliders.length == 0) {

            $('#map-hotels-slider').css('visibility', 'collapse');
            //templateItem.find('.error').text('0 hotel found').removeClass('text-warning');                
            //templateItem.find('.error-detail').text('no hotel found');
            //templateItem.find('.row-error').css('display', 'flex');
            //templateItem.find('.hotel-detail').css('display', 'none');
        } else {
            $('#map-hotels-slider').css('visiblity', 'visible');
        }

        if (markers.length > 1) {
            const start = markers[1];
            if (start != undefined)
                $("#mapDirectionStart").find(`option[value="${start.key}"]`).prop("selected", true);

            const end = markers[0];
            if (end != undefined)
                $("#mapDirectionEnd").find(`option[value="${end.key}"]`).prop("selected", true);

            if (allowCluster && mapView._clusterer != null) {
                mapView./*_clusterer.*/MarkerClusterer(map, clusterMarkers);
            }

            // insert detect ma position
            $('#mapDirectionStart')
                .append($(`<option value='0' >${mapView._local.myLocation}</option>`).attr('data-icon-url', '/images/icons/map/marker_pink.png').attr('data-icon-class-name', 'position'));

        }

        mapView.checkView();
    }

    public MarkerClusterer(map: google.maps.Map, markers: google.maps.marker.AdvancedMarkerElement[]) {
        if (this._clusterer == null) {
            this._clusterer = new MarkerClusterer({ map, markers });
        } else {
            this._clusterer.setMap(map);
            this._clusterer.addMarkers(markers);
        }
    }

    public setCenter(center: google.maps.LatLngLiteral) {

        if (this._map != null) {
            //this._map.setCenter(center);
            this._map.moveCamera({ center: center, heading: 1, tilt: 3 });
        } else {
            this._options.center = center;
        }

    }


}

export function getDistance(lat1, lon1, lat2, lon2): number {
    const R = 6371; // Rayon de la Terre en kilomètres
    const dLat = (lat2 - lat1) * Math.PI / 180; // Différence de latitude en radians
    const dLon = (lon2 - lon1) * Math.PI / 180; // Différence de longitude en radians

    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c; // Distance en kilomètres

    return distance;
}

// Attache MapView à window
window.MapView = MapView;